import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const CertificateEntry = () => {
  const navigate = useNavigate();
  const { token } = useParams();

  useEffect(() => {
    if (!token) return;

    const jwt = localStorage.getItem("jwtToken");
    if (jwt) {
      // Already logged in
            sessionStorage.setItem("pendingCertificateToken", token);
      navigate(`/certificate-action/${token}`, { state: { token } });
    } else {
      // Store token for after login
      sessionStorage.setItem("pendingCertificateToken", token);

      sessionStorage.setItem(
        "redirectAfterLogin",
        JSON.stringify({
          path: `/certificate-action/${token}`,
          state: { token },
        })
      );

      navigate("/login");
    }
  }, [token]);

  return <div>Processing link...</div>;
};

export default CertificateEntry;